import React from 'react'
import { Switch, Select, Typography, Form, Space } from 'antd'
const { Title, Text } = Typography
const { Option } = Select

// Per-document toggle: warn the signer when a completed signature with the same
// VPS account and number of shares already exists, and let them confirm before
// signing again. The admin chooses which form field is the VPS account and which
// is the number of shares.
const DuplicateCheckEditor = ({ fields = [], value = null, defaultVpsFieldKey, onChange }) => {
  const enabled = !!(value && value.enabled)
  const vpsFieldKey = (value && value.vpsFieldKey) || undefined
  const sharesFieldKey = (value && value.sharesFieldKey) || undefined

  // Always emit the full object so changing one select never drops the other.
  const emit = (patch) => {
    onChange({
      enabled,
      vpsFieldKey: vpsFieldKey || null,
      sharesFieldKey: sharesFieldKey || null,
      ...patch
    })
  }

  const toggle = (checked) => {
    // Default the VPS field to the whitelisted one when first enabling.
    emit({ enabled: checked, vpsFieldKey: vpsFieldKey || (checked ? (defaultVpsFieldKey || null) : null) })
  }

  const active = enabled && vpsFieldKey && sharesFieldKey

  return (
    <div>
      <Title level={5}>Duplicate signing check</Title>
      <Text type="secondary">
        Optional. Warn the signer when a signature with the same VPS account and number of shares has already been
        registered for this document, and ask them to confirm before signing again.
      </Text>
      <div style={{ marginTop: 12 }}>
        <Space>
          <Switch checked={enabled} onChange={toggle} />
          <Text>{enabled ? 'Enabled' : 'Disabled'}</Text>
        </Space>
      </div>
      {enabled && (
        <Form layout="vertical" style={{ marginTop: 12 }}>
          <Form.Item
            label="VPS account field"
            validateStatus={!vpsFieldKey ? 'warning' : ''}
            help={!vpsFieldKey ? 'Select the VPS account field' : undefined}
          >
            <Select
              placeholder="Select field"
              value={vpsFieldKey}
              onChange={(v) => emit({ vpsFieldKey: v || null })}
              style={{ maxWidth: 360 }}
              allowClear
            >
              {fields.map(f => <Option key={f.key} value={f.key}>{f.label || f.key}</Option>)}
            </Select>
          </Form.Item>
          <Form.Item
            label="Number of shares field"
            validateStatus={!sharesFieldKey ? 'warning' : ''}
            help={!sharesFieldKey ? 'Select the number-of-shares field' : undefined}
          >
            <Select
              placeholder="Select field"
              value={sharesFieldKey}
              onChange={(v) => emit({ sharesFieldKey: v || null })}
              style={{ maxWidth: 360 }}
              allowClear
            >
              {fields.map(f => <Option key={f.key} value={f.key}>{f.label || f.key}</Option>)}
            </Select>
          </Form.Item>
          <Text type={active ? 'success' : 'secondary'}>
            {active
              ? 'Active — signers will be warned on a matching VPS account + number of shares.'
              : 'Select both fields to activate the check.'}
          </Text>
        </Form>
      )}
    </div>
  )
}

export default DuplicateCheckEditor
